module.exports = __webpack_public_path__ + "img/BG.706ca31d.jpg";